var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"registerPage"},[_c('h2',[_vm._v("学籍注册系统")]),_c('div',{staticClass:"content-box",domProps:{"innerHTML":_vm._s(_vm.info.content)}}),_c('div',{staticClass:"create-btn",on:{"click":_vm.handleCreate}},[_vm._v("立即生成学籍号")]),_c('agreementDialog',{ref:"agreement"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }